import React, { Component } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { Image } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import {_axios} from '../plugins/axios';
import auth from '../auth/auth';
import { USER,URL } from '../constants/constant';
import logo from '../assets/MBWithName.png';

const validMobileRegex = RegExp(/^[6-9]\d{9}$/i);

class LoginComponent extends Component{
  constructor(props){
    super(props);
    console.log(this.props);
    this.state = {
        sendOTP : false,
        verifyOTP : false,
        phoneNumber: null,
        otp: null,
        errors: {
          phoneNumber: '',
          otp: '',
        },
        otpDataId : null,
        showMessage: null,
    }
  }
  
    resetState() {
        this.setState({
            sendOTP : false,
            verifyOTP : false,
            phoneNumber: null,
            otp: null,
            errors: {
            phoneNumber: '',
            otp: '',
            }
        })
    }

  sendOTP(){
    let that = this;
    let url = URL.dev_url;
    let route = url + 'sendotp'

    _axios.post(route,{phonenumber : this.state.phoneNumber.toString(), type: "OTP_Validation"})
    .then(function (response) {
        that.setState({
            sendOTP : response.data.success,
            otpDataId : response.data.otpDataId,
            showMessage : null
        })
    }).catch(function (error) {
        alert(error.response.data.message || error.message);
      })
  }

  verifyOtp(event){
     const { name, value } = event.target;
     if(value.length === 4){
         this.setState({
             otp : value
         })
     }else{
         console.log("otp..",value)
     }
      
  }

  handleSubmit = (event) => {
    let that = this;
    event.preventDefault();
    let url = URL.dev_url;
    let route = url + 'verifyotp'

    _axios.post(route,
        {phonenumber : this.state.phoneNumber, otp: this.state.otp, otpEvent : "login" , otpDataId: this.state.otpDataId ? this.state.otpDataId : null},
        {timeout: 60000} )
        .then(function (response) {
            console.log(response);
            if(response.data.success){
                if(response.data.otpStatus){
                    that.setState({
                      showMessage : null
                    },()=>{
                        auth.login(() => {
                            localStorage.setItem("access_token",response.data.userdetails.access_token);
                            localStorage.setItem("user_details",JSON.stringify(response.data.userdetails.user));
                            USER.user = response.data.userdetails.user;
                            let featureConfig = USER.user.featureConfig ? JSON.parse(USER.user.featureConfig) : null;
                            if(featureConfig?.isNewUpsellFlowLive){
                                that.props.history.push("/dependantOrders");
                            } else {
                                that.props.history.push("/orders");
                            }
                        });
                    })
                  }else if(!response.data.otpStatus){
                    that.setState({
                      showMessage : response.data.message
                    })
                  }
            }
        }).catch(function (error) {
            console.log(error);
        })
  }


  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case 'phoneNumber': 
        errors.phoneNumber = 
        validMobileRegex.test(value)
            ? ''
            : 'Phone Number must be 10 digits';
        break;
      default:
        break;
    }

    this.setState({errors, [name]: value});
  }

  submitForm = (event) => {
    event.preventDefault(); 
    if(!this.state.sendOTP){
        this.sendOTP(event) 
    } else {
        this.handleSubmit(event)
    }
  }

  render(){
    const {errors} = this.state;
    if(localStorage.getItem('access_token')){
        this.props.history.push('./orders')
    }
    
    return(
        <div className="login-screen">
                    <div className="login-form">
                        <Row className="width-full">
                            <Col xs={12} md={12}>
                                <div className="text-align-center p-t-20">
                                    <Image src={logo} className="width-65" />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-5 width-full">
                            <Col xs={12} md={12}>
                                <Form onSubmit={(e)=> this.submitForm(e)}>
                                    <Form.Group>
                                        <Form.Label htmlFor="phoneNumber">Phone Number</Form.Label>
                                        <Form.Control type="number" name='phoneNumber' placeholder="Enter Phone Number" onChange={(e)=>this.handleChange(e)} disabled={this.state.sendOTP}/>
                                        {errors.phoneNumber.length > 0 && 
                                        <span className='font-size-sm gray-color'>{errors.phoneNumber}</span>}
                                        <Form.Control.Feedback type="invalid">
                                            {errors.username}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    {!this.state.sendOTP && <div className="my-2 text-right">
                                        <Button variant="primary" type="submit" size="sm"> Request Otp </Button>
                                    </div>}
                                    
                                    <Form.Group>
                                        <Form.Label htmlFor="otp">OTP</Form.Label>
                                        <Form.Control type="password" name='otp' placeholder="OTP" onChange={(e)=>this.verifyOtp(e)} disabled={!this.state.sendOTP}/>
                                    
                                    </Form.Group>
                                    <div>
                                            <Button variant="primary" type="submit"  className="text-align-center w-100" disabled={!this.state.sendOTP}> LogIn </Button>
                                            {this.state.sendOTP && <div className="display-flex justify-content-space-between p-t-10">
                                                <div className="secondary-color font-size-smd bold" onClick={(e)=> this.resetState(e)}>Edit Phone Number</div>
                                                <div className="base-color font-size-smd bold" onClick={(e)=> this.sendOTP(e)}>Resend OTP</div>
                                            </div>}
                                    </div>
                                    <div className="text-align-center red-color font-size-smd bold p-t-10 ">
                                         {this.state.showMessage}
                                    </div>
                                </Form>
                            </Col>
                        
                        </Row>
                    </div>      
        </div>
        )
    }
}
export default LoginComponent;